var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"i-switch",on:{"mousedown":_vm.mouseDown,"mouseenter":_vm.mouseEnter,"mouseleave":_vm.mouseLeave,"mouseup":_vm.mouseUp}},[_c('div',{staticClass:"i-switch-cover",style:({
      'background-color': _vm.switchBgColor,
      width: _vm.iSize.width + 'vw',
      height: _vm.iSize.height + 'vw',
      'border-radius': _vm.iSize.height / 2 + 'vw'
    })},[_c('div',{staticClass:"i-switch-dot",style:(_vm.dotStyle)})])])}
var staticRenderFns = []

export { render, staticRenderFns }